<div class="page-container">
  <div class="page-shell">
    <section class="page-toolbar" testId="scheduled-task-toolbar">
      <div class="page-heading">
        <div class="title-row">
          <div class="title-copy">
            <span class="eyebrow">{{ 'scheduled-task.eyebrow' | i18n }}</span>
            <h1 class="page-title">{{ 'scheduled-task.title' | i18n }}</h1>
            <p class="page-subtitle">{{ 'scheduled-task.description' | i18n }}</p>
          </div>
          <div class="toolbar-actions">
            <button
              nz-button
              nzType="default"
              class="refresh-btn"
              type="button"
              (click)="refresh()"
              [nzLoading]="loading"
              testId="scheduled-task-refresh"
            >
              <i nz-icon nzType="reload"></i>
              {{ 'common.refresh' | i18n }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <div class="form-container">
      <div class="scheduled-task-page" testId="scheduled-task-page">
        <section class="task-toolbar task-toolbar--comfortable" aria-label="Task filters">
          <nz-input-group [nzPrefix]="searchIcon" class="task-search">
            <input
              nz-input
              type="search"
              [(ngModel)]="searchKey"
              (ngModelChange)="onTaskSearchChange($event)"
              [placeholder]="'scheduled-task.search-placeholder' | i18n"
              testId="scheduled-task-search"
            />
            <ng-template #searchIcon><i nz-icon nzType="search"></i></ng-template>
          </nz-input-group>
          <button
            *ngIf="searchKey"
            nz-button
            nzType="link"
            type="button"
            class="reset-search"
            (click)="resetSearch()"
            testId="scheduled-task-reset-search-button"
          >
            {{ 'common.reset' | i18n }}
          </button>
          <span class="task-count">{{ 'scheduled-task.total' | i18n: { total: taskTotal } }}</span>
        </section>

        <section class="task-table-shell" testId="scheduled-task-table-shell">
          <div class="task-table-scroll">
            <nz-table
              #taskTable
              class="task-table"
              [nzData]="tasks"
              [nzLoading]="loading"
              [nzFrontPagination]="false"
              [nzShowPagination]="false"
              nzSize="small"
              [nzScroll]="{ x: '1380px', y: '100%' }"
              testId="scheduled-task-table"
            >
              <thead>
                <tr>
                  <th scope="col" nzWidth="220px">{{ 'scheduled-task.column.name' | i18n }}</th>
                  <th scope="col" nzWidth="190px">{{ 'scheduled-task.column.service' | i18n }}</th>
                  <th scope="col" nzWidth="240px">{{ 'scheduled-task.column.cron' | i18n }}</th>
                  <th scope="col" nzWidth="140px">{{ 'scheduled-task.column.zone' | i18n }}</th>
                  <th scope="col" nzWidth="110px">{{ 'scheduled-task.column.status' | i18n }}</th>
                  <th scope="col" nzWidth="150px">{{ 'scheduled-task.column.latest-status' | i18n }}</th>
                  <th scope="col" nzWidth="80px">{{ 'scheduled-task.column.version' | i18n }}</th>
                  <th scope="col" nzWidth="250px" nzRight>{{ 'common.actions' | i18n }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let task of taskTable.data" [testId]="'scheduled-task-row-' + task.taskId">
                  <td>
                    <div class="task-identity">
                      <strong [title]="task.name">{{ task.name || '--' }}</strong>
                      <span class="mono truncate" [title]="task.taskId">{{ task.taskId }}</span>
                    </div>
                  </td>
                  <td
                    ><span class="truncate" [title]="task.targetService">{{ task.targetService || '--' }}</span></td
                  >
                  <td nzWidth="240px">
                    <div
                      class="cron-cell"
                      [nz-tooltip]="cronTooltipTpl"
                      nzTooltipPlacement="topLeft"
                      [testId]="'scheduled-task-cron-cell-' + task.taskId"
                    >
                      <div class="cron-desc">
                        <i nz-icon nzType="clock-circle" class="cron-desc-icon"></i>
                        <span class="cron-desc-text" [title]="getCronDisplayInfo(task).description" [testId]="'scheduled-task-cron-desc-' + task.taskId">
                          {{ getCronDisplayInfo(task).description }}
                        </span>
                      </div>
                      <div class="cron-code-row">
                        <code class="cron-raw-badge mono" [title]="task.cronExpression" [testId]="'scheduled-task-cron-raw-' + task.taskId">{{ task.cronExpression || '--' }}</code>
                        <button
                          *ngIf="task.cronExpression"
                          nz-button
                          nzType="text"
                          nzSize="small"
                          type="button"
                          class="cron-copy-btn"
                          (click)="copyCron($event, task.cronExpression)"
                          [nz-tooltip]="'scheduled-task.copy-cron' | i18n"
                          [testId]="'scheduled-task-copy-cron-' + task.taskId"
                        >
                          <i nz-icon nzType="copy"></i>
                        </button>
                      </div>
                    </div>

                    <ng-template #cronTooltipTpl>
                      <div class="cron-popover-content">
                        <div class="cron-popover-header">
                          <i nz-icon nzType="clock-circle"></i>
                          <strong>{{ getCronDisplayInfo(task).description }}</strong>
                        </div>
                        <div class="cron-popover-meta">
                          <div class="cron-popover-field">
                            <label>{{ 'scheduled-task.column.cron' | i18n }}:</label>
                            <code>{{ task.cronExpression }}</code>
                          </div>
                          <div class="cron-popover-field">
                            <label>{{ 'scheduled-task.column.zone' | i18n }}:</label>
                            <span>{{ task.zoneId || 'UTC' }}</span>
                          </div>
                        </div>
                        <div *ngIf="getCronDisplayInfo(task).nextRuns.length" class="cron-popover-runs">
                          <div class="cron-popover-runs-title">{{ 'scheduled-task.cron-preview.next-runs' | i18n }}:</div>
                          <ol class="cron-popover-runs-list">
                            <li *ngFor="let run of getCronDisplayInfo(task).nextRuns">{{ run }}</li>
                          </ol>
                        </div>
                      </div>
                    </ng-template>
                  </td>
                  <td>{{ task.zoneId || '--' }}</td>
                  <td
                    ><nz-tag [nzColor]="taskStatusColor(task.status)">{{ statusLabel(task.status) }}</nz-tag></td
                  >
                  <td
                    ><nz-tag [nzColor]="executionStatusColor(task.latestExecutionStatus)">{{
                      statusLabel(task.latestExecutionStatus)
                    }}</nz-tag></td
                  >
                  <td
                    ><span class="version-value">v{{ task.version }}</span></td
                  >
                  <td nzRight>
                    <div class="row-actions">
                      <button
                        nz-button
                        nzType="link"
                        type="button"
                        (click)="openEdit(task)"
                        [testId]="'scheduled-task-edit-' + task.taskId"
                      >
                        {{ 'common.edit' | i18n }}
                      </button>
                      <button
                        nz-button
                        nzType="link"
                        type="button"
                        [nzLoading]="statusUpdatingTaskId === task.taskId"
                        (click)="updateTaskStatus(task, nextTaskStatus(task))"
                        [testId]="'scheduled-task-status-' + task.taskId"
                      >
                        {{ statusLabel(nextTaskStatus(task)) }}
                      </button>
                      <button
                        nz-button
                        nzType="link"
                        type="button"
                        (click)="viewExecutions(task)"
                        [testId]="'scheduled-task-executions-' + task.taskId"
                      >
                        {{ 'scheduled-task.execution-records' | i18n }}
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>
          <footer *ngIf="taskTotal > 0" class="task-pagination-footer" testId="scheduled-task-pagination-footer">
            <div class="task-pagination-info" testId="scheduled-task-pagination-info">
              {{ 'common.total-records' | i18n: { total: taskTotal } }}
            </div>
            <div class="task-pagination-controls">
              <nz-pagination
                class="task-pagination"
                nzSize="small"
                [nzPageIndex]="taskPageIndex + 1"
                [nzPageSize]="taskPageSize"
                [nzTotal]="taskTotal"
                [nzShowSizeChanger]="true"
                [nzPageSizeOptions]="[15, 30, 50]"
                [nzShowQuickJumper]="taskTotal > taskPageSize"
                (nzPageIndexChange)="changeTaskPage($event)"
                (nzPageSizeChange)="changeTaskPageSize($event)"
                testId="scheduled-task-pagination"
              />
            </div>
          </footer>
        </section>
      </div>
    </div>
  </div>
</div>

<nz-modal
  nzClassName="scheduled-task-modal scheduled-task-edit-modal"
  [nzVisible]="editModalVisible"
  [nzTitle]="'scheduled-task.edit-title' | i18n"
  [nzOkText]="'common.save' | i18n"
  [nzCancelText]="'common.cancel' | i18n"
  [nzOkLoading]="saving"
  [nzOkDisabled]="!canSaveCron"
  [nzWidth]="620"
  (nzOnOk)="saveTask()"
  (nzOnCancel)="closeEdit()"
  testId="scheduled-task-edit-modal"
>
  <ng-container *nzModalContent>
    <div class="edit-form">
      <div class="task-context">
        <div>
          <strong>{{ editingTask?.name || '--' }}</strong>
          <span class="mono">{{ editForm.taskId }}</span>
        </div>
        <span class="task-zone"><i nz-icon nzType="global"></i>{{ editingTask?.zoneId || 'UTC' }}</span>
      </div>

      <section class="schedule-builder" testId="scheduled-task-schedule-builder">
        <div class="schedule-builder-title">
          <div>
            <span class="field-label">{{ 'scheduled-task.cron-editor.title' | i18n }}</span>
            <small>{{ 'scheduled-task.cron-editor.description' | i18n }}</small>
          </div>
          <span *ngIf="scheduleEditor.type !== 'custom'" class="sync-state">
            <i nz-icon nzType="sync"></i>{{ 'scheduled-task.cron-editor.synced' | i18n }}
          </span>
        </div>

        <div class="schedule-type-list" role="group" [attr.aria-label]="'scheduled-task.cron-editor.title' | i18n">
          <button
            *ngFor="let item of scheduleTypes"
            nz-button
            nzType="default"
            type="button"
            class="schedule-type"
            [class.schedule-type-active]="scheduleEditor.type === item.type"
            (click)="setScheduleType(item.type)"
            [testId]="'scheduled-task-schedule-type-' + item.type"
          >
            {{ item.labelKey | i18n }}
          </button>
        </div>

        <div *ngIf="scheduleEditor.type !== 'custom'" class="schedule-fields">
          <label *ngIf="scheduleEditor.type === 'minutes'" class="schedule-field">
            <span>{{ 'scheduled-task.cron-editor.interval' | i18n }}</span>
            <div class="number-with-unit">
              <nz-input-number
                [ngModel]="scheduleEditor.interval"
                (ngModelChange)="updateScheduleEditor({ interval: $event })"
                [nzMin]="1"
                [nzMax]="59"
                [nzStep]="1"
                testId="scheduled-task-interval-input"
              />
              <span class="schedule-unit">{{ 'scheduled-task.cron-editor.minutes-unit' | i18n }}</span>
            </div>
          </label>

          <label *ngIf="scheduleEditor.type === 'hourly'" class="schedule-field">
            <span>{{ 'scheduled-task.cron-editor.minute-of-hour' | i18n }}</span>
            <div class="number-with-unit">
              <nz-input-number
                [ngModel]="scheduleEditor.minute"
                (ngModelChange)="updateScheduleEditor({ minute: $event })"
                [nzMin]="0"
                [nzMax]="59"
                [nzStep]="1"
                testId="scheduled-task-minute-input"
              />
              <span class="schedule-unit">{{ 'scheduled-task.cron-editor.minute-unit' | i18n }}</span>
            </div>
          </label>

          <label *ngIf="scheduleEditor.type === 'weekly'" class="schedule-field schedule-field-wide">
            <span>{{ 'scheduled-task.cron-editor.weekday' | i18n }}</span>
            <nz-select
              [ngModel]="scheduleEditor.dayOfWeek"
              (ngModelChange)="updateScheduleEditor({ dayOfWeek: $event })"
              testId="scheduled-task-day-of-week-select"
            >
              <nz-option
                *ngFor="let day of weekDays"
                [nzValue]="day.value"
                [nzLabel]="day.labelKey | i18n"
                [testId]="'scheduled-task-weekday-option-' + day.value"
              />
            </nz-select>
          </label>

          <label *ngIf="scheduleEditor.type === 'monthly'" class="schedule-field">
            <span>{{ 'scheduled-task.cron-editor.day-of-month' | i18n }}</span>
            <div class="number-with-unit">
              <nz-input-number
                [ngModel]="scheduleEditor.dayOfMonth"
                (ngModelChange)="updateScheduleEditor({ dayOfMonth: $event })"
                [nzMin]="1"
                [nzMax]="31"
                [nzStep]="1"
                testId="scheduled-task-day-of-month-input"
              />
              <span class="schedule-unit">{{ 'scheduled-task.cron-editor.day-unit' | i18n }}</span>
            </div>
          </label>

          <div *ngIf="['daily', 'weekdays', 'weekly', 'monthly'].includes(scheduleEditor.type)" class="schedule-field schedule-field-time">
            <span>{{ 'scheduled-task.cron-editor.time' | i18n }}</span>
            <div class="time-editor">
              <nz-input-number
                [ngModel]="scheduleEditor.hour"
                (ngModelChange)="updateScheduleEditor({ hour: $event })"
                [nzMin]="0"
                [nzMax]="23"
                [nzStep]="1"
                [nzPlaceHolder]="'HH'"
                testId="scheduled-task-hour-input"
              />
              <span class="schedule-unit">{{ 'scheduled-task.cron-editor.hour-unit' | i18n }}</span>
              <nz-input-number
                [ngModel]="scheduleEditor.minute"
                (ngModelChange)="updateScheduleEditor({ minute: $event })"
                [nzMin]="0"
                [nzMax]="59"
                [nzStep]="1"
                [nzPlaceHolder]="'mm'"
                testId="scheduled-task-time-minute-input"
              />
              <span class="schedule-unit">{{ 'scheduled-task.cron-editor.minute-unit' | i18n }}</span>
            </div>
          </div>
        </div>

        <p *ngIf="scheduleEditor.type === 'custom'" class="custom-mode-note">
          <i nz-icon nzType="code"></i>
          {{ 'scheduled-task.cron-editor.custom-hint' | i18n }}
        </p>
      </section>

      <div class="cron-presets">
        <span class="field-label">{{ 'scheduled-task.cron-preset.label' | i18n }}</span>
        <div class="cron-preset-list">
          <button
            *ngFor="let preset of cronPresets"
            nz-button
            nzType="default"
            type="button"
            class="cron-preset"
            [class.cron-preset-active]="editForm.cronExpression.trim() === preset.expression"
            (click)="applyCronPreset(preset)"
            [testId]="'scheduled-task-cron-preset-' + preset.labelKey"
          >
            {{ preset.labelKey | i18n }}
          </button>
        </div>
      </div>
      <label for="scheduled-task-cron">{{ 'scheduled-task.cron-editor.expression-output' | i18n }}</label>
      <div class="cron-input-wrap" [class.cron-input-wrap-invalid]="cronPreview.status === 'invalid'">
        <input
          id="scheduled-task-cron"
          nz-input
          [ngModel]="editForm.cronExpression"
          (ngModelChange)="onCronExpressionChange($event)"
          autocomplete="off"
          spellcheck="false"
          testId="scheduled-task-cron-input"
        />
        <i *ngIf="cronPreview.status === 'valid'" nz-icon nzType="check-circle" class="cron-input-status cron-input-status-valid"></i>
        <i
          *ngIf="cronPreview.status === 'invalid'"
          nz-icon
          nzType="exclamation-circle"
          class="cron-input-status cron-input-status-invalid"
        ></i>
      </div>
      <span class="field-hint">{{ 'scheduled-task.cron-hint' | i18n }}</span>

      <section
        *ngIf="cronPreview.status !== 'empty'"
        class="cron-preview"
        [class.cron-preview-invalid]="cronPreview.status === 'invalid'"
        [class.cron-preview-unsupported]="cronPreview.status === 'unsupported'"
        aria-live="polite"
        testId="scheduled-task-cron-preview"
      >
        <div class="cron-preview-heading">
          <i
            nz-icon
            [nzType]="cronPreview.status === 'valid' ? 'calendar' : cronPreview.status === 'invalid' ? 'close-circle' : 'info-circle'"
          ></i>
          <div>
            <strong *ngIf="cronPreview.status === 'valid'">
              {{ formatCronDescription(cronPreview) }}
            </strong>
            <strong *ngIf="cronPreview.status === 'invalid'">
              {{ cronPreview.errorKey || 'scheduled-task.cron-error.invalid' | i18n }}
            </strong>
            <strong *ngIf="cronPreview.status === 'unsupported'">{{ 'scheduled-task.cron-preview.unsupported-title' | i18n }}</strong>
            <span *ngIf="cronPreview.status === 'valid'">{{ 'scheduled-task.cron-preview.next-runs' | i18n }}</span>
            <span *ngIf="cronPreview.status === 'unsupported'">{{ 'scheduled-task.cron-preview.unsupported-hint' | i18n }}</span>
          </div>
        </div>

        <ol *ngIf="cronPreview.status === 'valid' && cronPreview.nextRuns.length" class="cron-next-runs">
          <li *ngFor="let run of cronPreview.nextRuns; let index = index">
            <span>{{ index + 1 }}</span>
            <time>{{ run }}</time>
          </li>
        </ol>
        <p *ngIf="cronPreview.status === 'valid' && !cronPreview.nextRuns.length" class="cron-preview-note">
          {{ 'scheduled-task.cron-preview.no-runs' | i18n }}
        </p>
        <p *ngIf="cronPreview.status === 'valid'" class="cron-preview-note">
          <i nz-icon nzType="experiment"></i>{{ 'scheduled-task.cron-preview.simulation-only' | i18n }}
        </p>
      </section>
    </div>
  </ng-container>
</nz-modal>

<nz-modal
  nzClassName="scheduled-task-modal scheduled-task-execution-modal"
  [nzVisible]="executionModalVisible"
  [nzTitle]="executionModalTitle"
  [nzFooter]="null"
  [nzWidth]="1320"
  (nzOnCancel)="closeExecutions()"
  testId="scheduled-task-execution-modal"
>
  <ng-container *nzModalContent>
    <nz-spin [nzSpinning]="executionLoading">
      <div class="execution-overview">
        <div class="execution-task-context">
          <span>{{ selectedTask?.targetService || '--' }}</span>
          <strong class="mono">{{ selectedTask?.taskId || '--' }}</strong>
        </div>
        <div class="execution-order">
          <span>{{ 'scheduled-task.execution.latest-first' | i18n }}</span>
          <span class="execution-total">{{ 'scheduled-task.execution.total' | i18n: { total: executionTotal } }}</span>
        </div>
      </div>
      <nz-table
        #executionTable
        class="execution-table"
        [nzData]="executions"
        [nzFrontPagination]="false"
        [nzPageIndex]="executionPageIndex + 1"
        [nzPageSize]="executionPageSize"
        [nzTotal]="executionTotal"
        [nzShowSizeChanger]="true"
        (nzPageIndexChange)="changeExecutionPage($event)"
        (nzPageSizeChange)="changeExecutionPageSize($event)"
        nzSize="small"
        [nzScroll]="{ x: '1140px', y: 'min(56vh, 560px)' }"
        testId="scheduled-task-execution-table"
      >
        <thead>
          <tr>
            <th scope="col" nzWidth="250px">{{ 'scheduled-task.execution.id' | i18n }}</th>
            <th scope="col" nzWidth="180px">{{ 'scheduled-task.execution.scheduled-at' | i18n }}</th>
            <th scope="col" nzWidth="120px">{{ 'scheduled-task.column.status' | i18n }}</th>
            <th scope="col" nzWidth="430px">{{ 'scheduled-task.execution.message' | i18n }}</th>
            <th scope="col" nzWidth="160px">{{ 'common.actions' | i18n }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let execution of executionTable.data" [testId]="'scheduled-task-execution-row-' + execution.executionId">
            <td
              ><span class="mono truncate" [title]="execution.executionId">{{ execution.executionId }}</span></td
            >
            <td>{{ execution.scheduledAt ? (execution.scheduledAt | date: 'yyyy-MM-dd HH:mm:ss') : '--' }}</td>
            <td
              ><nz-tag [nzColor]="executionStatusColor(execution.status)">{{ statusLabel(execution.status) }}</nz-tag></td
            >
            <td
              ><div class="execution-message">{{ execution.message || '--' }}</div></td
            >
            <td>
              <div class="row-actions">
                <button
                  *ngIf="execution.hasOnceExecutionLog === true"
                  nz-button
                  nzType="link"
                  type="button"
                  (click)="viewOnceLogs(execution)"
                  [testId]="'scheduled-task-view-once-logs-btn-' + execution.executionId"
                >
                  {{ 'scheduled-task.once-logs' | i18n }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-spin>
  </ng-container>
</nz-modal>

<nz-modal
  nzClassName="scheduled-task-modal scheduled-task-once-log-modal"
  [nzVisible]="onceLogModalVisible"
  [nzTitle]="onceLogModalTitle"
  [nzFooter]="null"
  [nzWidth]="1240"
  (nzOnCancel)="closeOnceLogs()"
  testId="scheduled-task-once-log-modal"
>
  <ng-container *nzModalContent>
    <nz-spin [nzSpinning]="onceLogLoading">
      <nz-table
        #onceLogTable
        [nzData]="onceLogs"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        nzSize="small"
        [nzScroll]="{ x: '1100px', y: '460px' }"
        testId="scheduled-task-once-log-table"
      >
        <thead>
          <tr>
            <th scope="col" nzWidth="210px">{{ 'scheduled-task.once-log.id' | i18n }}</th>
            <th scope="col" nzWidth="130px">{{ 'scheduled-task.once-log.type' | i18n }}</th>
            <th scope="col" nzWidth="160px">{{ 'scheduled-task.once-log.entity' | i18n }}</th>
            <th scope="col" nzWidth="120px">{{ 'scheduled-task.column.status' | i18n }}</th>
            <th scope="col" nzWidth="90px">{{ 'scheduled-task.once-log.attempt' | i18n }}</th>
            <th scope="col" nzWidth="160px">{{ 'scheduled-task.once-log.worker' | i18n }}</th>
            <th scope="col">{{ 'scheduled-task.execution.message' | i18n }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of onceLogTable.data" [testId]="'scheduled-task-once-log-row-' + log.onceTaskId">
            <td
              ><span class="mono truncate" [title]="log.onceTaskId">{{ log.onceTaskId }}</span></td
            >
            <td>{{ log.taskType || '--' }}</td>
            <td
              ><span class="mono truncate" [title]="log.entityId">{{ log.entityId || '--' }}</span></td
            >
            <td
              ><nz-tag [nzColor]="executionStatusColor(log.status)">{{ statusLabel(log.status) }}</nz-tag></td
            >
            <td>{{ log.attempt ?? 0 }}</td>
            <td
              ><span class="mono truncate" [title]="log.workerId">{{ log.workerId || '--' }}</span></td
            >
            <td
              ><span class="truncate" [title]="log.message">{{ log.message || '--' }}</span></td
            >
          </tr>
        </tbody>
      </nz-table>
    </nz-spin>
  </ng-container>
</nz-modal>
